// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Libraries
import { map } from 'rxjs';

// Models
import { AppCleanup } from '../../../../shared/models';
import { DeviceModel, DeviceTypeViewModel, DeviceViewModel } from '../models/device.model';

@Injectable({
	providedIn: 'root',
})
export class DeviceService extends AppCleanup {
	private readonly deviceUrl: string;
	private readonly viewerDeviceUrl: string;
	
	constructor(private http: HttpClient) {
		super();
		this.deviceUrl = `${this.apiUrl}api/iotdevice`;
		this.viewerDeviceUrl = `${this.apiUrl}api/LvIoTDevice`;
	}
	
	getDevices() {
		if (this.isEdge) {
			return this.http.get<DeviceViewModel>(`${this.viewerDeviceUrl}/devicedetails`).pipe(
				map((device) => [device]) // Wrap the single object in an array
			);
		} else {
			return this.http.get<DeviceViewModel[]>(this.deviceUrl);
		}
	}
	
	getDevice(machineName: string) {
		return this.http.get<DeviceViewModel>(`${this.deviceUrl}/${machineName}`);
	}
	
	getDeviceTypes() {
		if (this.isEdge) {
			return this.http.get<DeviceTypeViewModel[]>(`${this.viewerDeviceUrl}/types`);
		} else {
			return this.http.get<DeviceTypeViewModel[]>(`${this.deviceUrl}/types`);
		}
	}
	
	createDevice(model: DeviceModel) {
		return this.http.post<DeviceViewModel>(this.deviceUrl, model);
	}
	
	updateDevice(model: DeviceModel) {
		return this.http.put<DeviceViewModel>(`${this.deviceUrl}/${model.machineName}`, model);
	}
	
	deprovisionDevice(machineName: string) {
		return this.http.post<DeviceViewModel>(`${this.deviceUrl}/deprovision/${machineName}`, {});
	}
	
	deviceModuleCommands(machineName, targetModule, commandName) {
		let url = this.isEdge ? this.viewerDeviceUrl : this.deviceUrl;
		let commandModel: ModuleCommandModel = {
			machineName: machineName,
			targetModule: targetModule,
			commandName: commandName,
		};
		
		return this.http.post<ModuleCommandModel>(`${url}/modulecommands`, commandModel);
	}
}

export class ModuleCommandModel {
	machineName: string;
	targetModule: string;
	commandName: string;
}